import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueTheMask from 'vue-the-mask'
import moment from 'moment'
import Professional from './components/Professional';
import Personal from './components/Personal';
import TimeOff from './components/TimeOff';
import Pto from './components/Pto'
import PtoRequest from './components/PtoRequest'
import PtoBalance from './components/PtoBalance'
import PtoManager from './components/PtoManager'
import PtoCompressed from './components/PtoCompressed'

Vue.config.productionTip = false

Vue.use(VueRouter)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM D, YYYY')
  }
})

const routes = [
  { path: '', component: Professional },
  { path: '/professional', component: Professional },
  { path: '/personal', component: Personal },
  { path: '/time-off', component: TimeOff },
  {
    path: '/pto', component: Pto,
    children: [
      { path: '', component: PtoRequest },
      { path: 'request', component: PtoRequest },
      { path: 'balancePrev', component: PtoBalance },      
      { path: 'balance', component: PtoBalance },
      { path: 'balanceNext', component: PtoBalance },
      { path: 'manager', component: PtoManager },
      { path: 'compressed', component: PtoCompressed }
    ],
  },
  { path: '/Benefits', beforeEnter() { location.href = 'https://class.adelphi.edu/benefits/' } },
  { path: '/Totals', beforeEnter() {location.href = 'https://class.adelphi.edu/benefits-report/'} }  
]

// mode: 'history',
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

new Vue({
  vuetify,
  router,
  VueTheMask,
  render: h => h(App)
}).$mount('#app')

